import { useEffect, useState } from 'react';
import messages from '../../statics/messages.json';
import { getParts, handleConnectClick } from '../../context/CommonContex';
const Historical = () => {
        const [parts,setParts] = useState([]);
        const [totalRecords, setTotalRecords] = useState(0);
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(10);
        const [iframeUrl, setIframeUrl] = useState(null);
        const totalPages = Math.ceil(totalRecords / itemsPerPage);
        const handlePageChange = (page) => {
            if (page < 1 || page > totalPages)
                return;
            setCurrentPage(page);
        };

        useEffect(() => {
            const fetchParts = async () => {
                const resultParts = await getParts((currentPage - 1) * itemsPerPage, itemsPerPage);
                setParts(resultParts.parts);
                setTotalRecords(resultParts.totalRecords);
            };
        
            fetchParts(); // Call the async function
        }, [currentPage, itemsPerPage]);
        
         
//  const handleConnectClick = () => {
//     debugger
//     const clientId = '1000.';
//     const redirectUri = 'http://localhost:5000/oauth/callback'; 
//     const scope = 'ZohoBigin.modules.ALL';
//     const authUrl = `https://accounts.zoho.com/oauth/v2/auth?scope=${scope}&client_id=${clientId}&response_type=code&access_type=offline&redirect_uri=${redirectUri}`;
    
//     // Redirect to Zoho OAuth URL
//     //window.location.href = authUrl;
//     setIframeUrl(authUrl);
// };


    return (
        <div className="box-body border b-white rounded-2">        
            <h4 className="p-2 m-0 border-bottom">Historical Demand Report</h4>
            <div className="row p-2">
                {/* <div className='col-lg-12'>

                {iframeUrl && (
                <iframe
                    src={iframeUrl}
                    style={{
                        width: '100%',
                        height: '500px',
                        border: 'none',
                    }}
                    title="Zoho OAuth"
                ></iframe>
            )}
                </div> */}
                <div className="col-1 d-flex justify-content-start align-items-bottom">
                

                <select
                        className="px-3 py-1 border rounded-1 d-inline"
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value="10">10</option>
                    </select>
                </div>
                <div className="col-8"></div>
                <div className="col-3">
                    <input type="text" className="form-control" placeholder={messages.search_label} />
                </div>
                <div className="col-12 py-2">
                    <div style={{ overflow: 'auto', whiteSpace: 'nowrap' }} className="table-responsive bridge-manual-scroll">
                       

                    <table className="table border rounded">
                                <thead class="table-sticky-head">
                                    <tr>
                                    <th className="text-center">{messages.part_lable}</th>
                                    <th className="text-center">{messages.uom_label}</th>
                                    <th className="text-center">{messages.qoh_label}</th>
                                    <th className="text-center">{messages.qr_label}</th>
                                    <th className="text-center">{messages.qoo_label}</th>
                                    <th className="text-center">{messages.rop_label}</th>
                                    <th className="text-center">{messages.qty_req_label}</th>
                                    <th className="text-center">{messages.avail_label}</th>
                                    <th className="text-center">{messages.total_pipeln_label}</th>
                                    <th className="text-center">{messages.short_pys_label}</th>
                                    <th className="text-center">{messages.py_x_label}</th>
                                    <th className="text-center">{messages.total_pys_label}</th>
                                    <th className="text-center">{messages.avg_mopys_label}</th>
                                    <th className="text-center">{messages.sold_ytd_label}</th>
                                    <th className="text-center">{messages.avg_moytd_label}</th>
                                    <th className="text-center">{messages.avg_cost_label}</th>
                                    <th className="text-center">{messages.inv_value_label}</th>
                                    <th className="text-center">{messages.prc_label}</th>
                                    <th className="text-center">{messages.last_shpmt_label}</th>
                                    <th className="text-center">{messages.last_rptdte_label}</th>
                                    <th className="text-center">{messages.ord_rpt_label}</th>
                                    <th className="text-center">{messages.ttl_ordered_sold_label}</th>
                                    <th className="text-center">{messages.sixm_usage_label}</th>
                                    <th className="text-center">{messages.sixm_avg_label}</th>
                                    <th className="text-center">{messages.ttl_block_label}</th>
                                    <th className="text-center">{messages.pst_mnth_ttl_label}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {parts != undefined && parts.length > 0 ? (
                                        parts.map((part, index) => {
                                       
                                            var partCache = JSON.parse(part.part_data_cache);

                                        return (
                                            <tr key={`${part.id}-${index}`}>
                                                <td>{partCache.prcpart}</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                                <td>abc</td>
                                            </tr>
                                        );
                                        })
                                    ) : (
                                        <tr>
                                        <td colSpan="26" style={{textAlign:"center"}}>No data available</td>
                                        </tr>
                                    )}
                                    </tbody>

                               
                            </table>
                    </div>
                </div>
                {/* <div className="col-12 py-2">
                    <nav aria-label="Page navigation example">
                        <span>
                            Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalRecords)} of {totalRecords}
                        </span>
                        <ul className="pagination float-end">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, index) => (
                                
                                <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div> */}
                <div className="col-12 py-2">
    <nav aria-label="Page navigation example">
        <span>
            Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalRecords)} of {totalRecords}
        </span>
        <ul className="pagination float-end">
            {/* Previous button */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
            </li>

            {/* Pagination items */}
            {[...Array(totalPages)].map((_, index) => {
                if (index + 1 > 10) {
                    // Insert a select box for pages greater than 10
                    if (index === 10) { // Only insert select box once at position 11
                        return (
                            <li key="select-box" className="page-item">
                                <select className="form-select page-link rounded-0"
                                    onChange={(e) => handlePageChange(Number(e.target.value))}
                                    value={currentPage > 10 ? currentPage : ''}
                                >
                                    
                                    {Array.from({ length: totalPages - 10 }, (_, i) => (
                                        <option key={i + 11} value={i + 11}>{i + 11}</option>
                                    ))}
                                </select>
                            </li>
                        );
                    }
                    return null; // Don't render other items after 10
                }

                return (
                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                    </li>
                );
            })}

            {/* Next button */}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
            </li>
        </ul>
    </nav>
</div>

            </div>
        </div>
    );
};

export default Historical;
